// removed by extract-text-webpack-plugin
module.exports = {"contact":"_3R0FfcQmQrPANwgWOGbhXQ_0","intro":"_3pLCZucRakGLhytchJz2ri_0","form":"_1UNTdGa9Ib2LkNUUC-nAxB_0"};


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"extract":true,"remove":true}!./~/vue-style-loader!./~/css-loader?{"sourceMap":true,"localIdentName":"[hash:base64]_0","modules":true,"importLoaders":true}!./~/vue-loader/lib/style-rewriter.js?id=data-v-51beda60!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/Contact.vue
// module id = 58
// module chunks = 2